module.exports = __webpack_public_path__ + "img/a11_3.c5445cc1.jpg";